import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/72_card_back_classic_purple/72_card_back_classic_purple"
 * Contains 1 texture(s)
 */
export class CardsBacks72CardBackClassicPurpleAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/72_card_back_classic_purple/72_card_back_classic_purple';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '72_classic_purple.png'
    ] as const;
}
